import { FilterOption } from '../components/custom-input/FilterDropdown';

export const COUNTRY_CODES = [{ name: 'New Zealand', value: 'NewZealand' }];

export const COUNTRIES_WITH_REGIONS: { [key: string]: FilterOption<string>[] } = {
  NewZealand: [
    { name: 'Auckland', value: 'Auckland' },
    { name: 'Bay of Plenty', value: 'Bay of Plenty' },
    { name: 'Canterbury', value: 'Canterbury' },
    { name: 'Gisborne', value: 'Gisborne' },
    { name: 'Hawke’s Bay', value: 'Hawke’s Bay' },
    { name: 'Manawatū–Whanganui', value: 'Manawatū–Whanganui' },
    { name: 'Marlborough', value: 'Marlborough' },
    { name: 'Nelson', value: 'Nelson' },
    { name: 'Northland', value: 'Northland' },
    { name: 'Otago', value: 'Otago' },
    { name: 'Southland', value: 'Southland' },
    { name: 'Taranaki', value: 'Taranaki' },
    { name: 'Tasman', value: 'Tasman' },
    { name: 'Waikato', value: 'Waikato' },
    { name: 'Wellington', value: 'Wellington' },
    { name: 'West Coast', value: 'West Coast' },
  ],
};

export const METHOD_OPTIONS: FilterOption<string>[] = [
  { name: 'Conventional', value: 'Conventional' },
  { name: 'IVF', value: 'IVF' },
];
